// Auto-generated file - do not edit manually
export const LOCALE_HASH = '29f5e04a';
